import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import type { Dayjs } from 'dayjs';
import { USER_STATUS } from '@/models/references/references';
import { referenceOf } from '@/stores/useReferenceOptions';

/**
 * POST /user_status_histories {user, userStatus} : activation / désactivation manuelle (refusée si le user est géré par un IAM).
 * GET : historique des statuts d'un user (fiche utilisateur).
 */
export default class UserStatusHistoryModel extends AbstractApiModel {
  protected _path = '/user_status_histories/{?id}';

  declare _tsFilters: { user?: string };
  declare _tsSorts: { createdAt?: unknown };

  @doc.date declare createdAt: Dayjs;
  @doc.string declare createdBy: string;

  get isEnabled(): boolean {
    return (
      referenceOf('userStatuses', this.get<unknown, unknown>('userStatus', null))?.reference === USER_STATUS.ENABLED
    );
  }

  get userStatusLabel(): string {
    return referenceOf('userStatuses', this.get<unknown, unknown>('userStatus', null))?.label ?? '';
  }
}
